// ============================================================
// Spielwache: Verlassen-Warnung + "Spiel fortsetzen"
//
// Produkttest 29.08.2026, Befund "Kein lokaler Spielstand ueberlebt einen
// Reload, keine Verlassen-Warnung": Ein Wischen am Handy oder ein Reload
// beendete jedes lokale Spiel ohne Rueckfrage; nur Online-Spiele und das
// Scoring-Training kamen zurueck.
//
// EIN BESITZER fuer beide Sorgen (Sichtbarkeitsregel aus CLAUDE.md):
//
//   1. WARNUNG  - solange ein lokales Spiel laeuft, fragt der Browser vor
//      Reload/Schliessen nach (beforeunload). Scharf von
//      spielwacheSpielGestartet() bis spielwacheSpielBeendet() bzw.
//      spielwachePausiert() (goHome).
//
//   2. SPIEGEL  - Modi mit sichern-Funktion werden nach jeder Aufnahme
//      nach localStorage gespiegelt (Muster aus game-scoring.js). Die
//      Kachel #fortsetzen-kachel im Hauptmenue bietet den Stand nach
//      einem Reload wieder an.
//
// WER WAS AUFRUFT
//   startXGame()        -> spielwacheSpielGestartet(modus, sichernFn|null)
//   updateX...()        -> spielwacheTick()          (nach jeder Aufnahme)
//   finishXGame()       -> spielwacheSpielBeendet()  (auch: expliziter Abbruch)
//   goHome()            -> spielwachePausiert()      (Warnung aus, Spiegel
//                          BLEIBT - wer mitten im Spiel wegklickt, kann
//                          zurueck; nur Beenden/Verwerfen loescht)
//   Modul-Ladezeit      -> spielwacheRegistriereFortsetzen(modus, name, fn)
//
// 501 lokal und Secure lokal melden sich nur fuer die WARNUNG an
// (sichern = null): Ihr Zustand ist deutlich groesser (Legs, Bull-Off,
// Undo-Stack, Bots) - die Spiegelung dort ist als offener Punkt in der
// Umsetzungs-Doku vermerkt, die Warnung schuetzt sie ab sofort.
// ============================================================

import { t } from "./i18n.js";

const WACHE_SCHLUESSEL = "secure-darts:laufendes-spiel";

let aktiv = null; // { modus, sichern|null }
const fortsetzbar = {}; // modus -> { anzeige, stelleWieder }

function spielwacheSpielGestartet(modus, sichern) {
  aktiv = { modus, sichern: typeof sichern === "function" ? sichern : null };
  spielwacheTick();
  aktualisiereFortsetzenKachel();
}

/** Nach jeder Aufnahme aufrufen - liest den Stand frisch und spiegelt ihn. */
function spielwacheTick() {
  if (!aktiv || !aktiv.sichern) return;
  try {
    localStorage.setItem(
      WACHE_SCHLUESSEL,
      JSON.stringify({ modus: aktiv.modus, stand: aktiv.sichern(), zeit: Date.now() }),
    );
  } catch (fehler) {
    // Privater Modus oder voller Speicher - dann gibt es eben kein
    // Fortsetzen. Die Warnung funktioniert trotzdem.
  }
}

/** Spiel regulaer beendet oder ausdruecklich abgebrochen: alles weg. */
function spielwacheSpielBeendet() {
  aktiv = null;
  try {
    localStorage.removeItem(WACHE_SCHLUESSEL);
  } catch (fehler) {
    /* s. o. */
  }
  aktualisiereFortsetzenKachel();
}

/** Heimweg ohne ausdrueckliches Ende (goHome): Warnung entschaerfen,
 *  den Spiegel aber behalten - daraus lebt die Fortsetzen-Kachel. */
function spielwachePausiert() {
  aktiv = null;
}

function spielwacheRegistriereFortsetzen(modus, anzeige, stelleWieder) {
  fortsetzbar[modus] = { anzeige, stelleWieder };
}

function gespeichertesSpiel() {
  try {
    const roh = localStorage.getItem(WACHE_SCHLUESSEL);
    if (!roh) return null;
    const daten = JSON.parse(roh);
    if (!daten || !daten.modus || !fortsetzbar[daten.modus]) return null;
    return daten;
  } catch (fehler) {
    return null;
  }
}

function aktualisiereFortsetzenKachel() {
  const kachel = document.getElementById("fortsetzen-kachel");
  if (!kachel) return;
  const daten = aktiv ? null : gespeichertesSpiel();
  if (!daten) {
    kachel.style.display = "none";
    return;
  }
  const modusZeile = document.getElementById("fortsetzen-modus");
  if (modusZeile) modusZeile.textContent = fortsetzbar[daten.modus].anzeige;
  kachel.style.display = "";
}

function fortsetzenKachelWeiter() {
  const daten = gespeichertesSpiel();
  if (!daten) {
    aktualisiereFortsetzenKachel();
    return;
  }
  try {
    fortsetzbar[daten.modus].stelleWieder(daten.stand);
  } catch (fehler) {
    // Ein kaputter Stand (z. B. aus einer aelteren Version) darf die App
    // nicht festhalten: verwerfen und sagen, was passiert ist.
    spielwacheSpielBeendet();
    if (typeof showToast === "function") showToast(t("js.wache.fehler"), "error");
  }
}

function fortsetzenKachelVerwerfen() {
  spielwacheSpielBeendet();
}

window.addEventListener("beforeunload", (ereignis) => {
  if (!aktiv) return;
  // Standardverhalten: Der Browser zeigt seine eigene Rueckfrage.
  ereignis.preventDefault();
  ereignis.returnValue = "";
});

if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", aktualisiereFortsetzenKachel);
  } else {
    aktualisiereFortsetzenKachel();
  }
}

// ---------------------------------------------------------------
// Bruecke zu window (Muster wie in allen uebrigen Modulen).
// ---------------------------------------------------------------
Object.assign(window, {
  spielwacheSpielGestartet,
  spielwacheTick,
  spielwacheSpielBeendet,
  spielwachePausiert,
  spielwacheRegistriereFortsetzen,
  aktualisiereFortsetzenKachel,
  fortsetzenKachelWeiter,
  fortsetzenKachelVerwerfen,
});
